import { render, staticRenderFns } from "./CertificateCreate.vue?vue&type=template&id=46549e78&scoped=true&"
import script from "./CertificateCreate.vue?vue&type=script&lang=js&"
export * from "./CertificateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46549e78",
  null
  
)

export default component.exports